import { useEffect, useState } from 'react';
import { OtpVerification } from '@commerce-identity-webcomponents/ui';
import type { AppDispatch, AppState } from '@nextgen-web-framework/core';
import { useDispatch, useSelector } from 'react-redux';
import {
  profileApi,
  updateRegistrationData,
  type CreateChallengeRequest,
  type RegistrationNextHandlerPatchPayload,
} from '@commerce-profile-webcomponents/sdk';
import ApiErrorModal from '../ApiErrorModal/ApiErrorModal';
import { useGlobalErrorHandler } from '../../utils/globalErrorHook';
import { ApiErrorModalProps } from '../ApiErrorModal/types/propTypes';
import type { RegistrationUsernameVerificationProps } from './types/propTypes';

const RegistrationUsernameVerification = ({ nextHandler }: RegistrationUsernameVerificationProps) => {
  const dispatch = useDispatch<AppDispatch>();
  const registrationFlowData = useSelector((state: AppState) => state.commerceProfile.registrationFlowData);
  const [modalErrorData, setModalErrorData] = useState<ApiErrorModalProps>();
  const apiErrorHandler = useGlobalErrorHandler();
  const errorHandler = (code: string) => {
    setModalErrorData({
      headline: `profile.ApiErrorModal.${code}.headline`,
      body: `profile.ApiErrorModal.${code}.body`,
    });
  };
  const generateChallengeId = async () => {
    const payload: CreateChallengeRequest = {
      [usernameType]: modValue,
    };
    if (registrationId) {
      const challengeRes = await apiErrorHandler(() =>
        profileApi.postRegistrationChallenge({
          payload,
          registrationId,
        }),
      );
      dispatch(
        updateRegistrationData({
          ...registrationFlowData,
          signupFormData: {
            ...signupFormData,
            generateOtp: false,
          },
          OtpData: {
            ...OtpData,
            challengeId: challengeRes.challengeId,
          },
        }),
      );
    }
  };
  useEffect(() => {
    if (generateOtp) {
      generateChallengeId();
    }
  }, []);
  const { signupFormData, OtpData, userData } = registrationFlowData;
  const { modValue, usernameType, generateOtp } = signupFormData;
  const { challengeId } = OtpData;
  const { patchVersion, registrationId } = userData;
  const otpVerifiedHandler = () => {
    dispatch(
      updateRegistrationData({
        ...registrationFlowData,
        OtpData: {
          ...OtpData,
          isOTPVerified: true,
        },
      }),
    );
  };
  const changeUserNameHandler = () => {
    dispatch(
      updateRegistrationData({
        ...registrationFlowData,
        isChangeUsernameModalOpen: true,
      }),
    );
  };

  const nextButtonHandler = async () => {
    const payload: RegistrationNextHandlerPatchPayload = {
      version: patchVersion,
      otpRequestId: challengeId,
    };
    otpVerifiedHandler();

    const response = await Promise.resolve(nextHandler(payload));
    if (response?.responseBody) {
      const { code } = response.responseBody;
      errorHandler(code);
    }
  };

  return (
    <div>
      <div data-testid="registration-user-verification-identity-component">
        <OtpVerification
          challengeId={challengeId}
          username={modValue}
          callback={nextButtonHandler}
          showChangeCTA={true}
          onChangeCTA={changeUserNameHandler}
          onClose={() => {
            //if (!isOTPVerified) {
            //    dispatch(
            //      updateRegistrationData({
            //        ...registrationFlowData,
            //        isRedirectedFromModal: true,
            //        isChangeUsernameModalOpen: false,
            //        currentIndex: currentIndex - 1,
            //        currentStepName: 'userDetailsStep',
            //        signupFormData: {
            //          ...signupFormData,
            //          userName: '',
            //          dialCode: '',
            //        },
            //      }),
            //    );
            //   }
          }}
        />
      </div>
      {(modalErrorData?.headline || modalErrorData?.body) && <ApiErrorModal {...modalErrorData} />}
    </div>
  );
};
export default RegistrationUsernameVerification;
